import * as React from 'react'
import { connect } from 'react-redux'
import type { State } from 'types/redux'
import DocumentHeadTags from 'components/document-head-tags'

function mapStateToProps(state: State): any {
  let css = null

  if (state.user.business) {
    css = state.user.business.css
  } else if (window.business_data) {
    css = window.business_data.css
  }

  return {
    css,
  }
}

class CustomCss extends React.Component<{
  css: string | null | undefined
}> {
  render() {
    const { css } = this.props
    return (
      <DocumentHeadTags
        style={[
          {
            type: 'text/css',
            cssText: css,
          },
        ]}
      />
    )
  }
}

export default connect(mapStateToProps)(CustomCss) as any
